import { render } from "./customer_services_with_customer_id.vue?vue&type=template&id=52ec8c80&scoped=true"
import script from "./customer_services_with_customer_id.vue?vue&type=script&lang=js"
export * from "./customer_services_with_customer_id.vue?vue&type=script&lang=js"

import "./customer_services_with_customer_id.vue?vue&type=style&index=0&id=52ec8c80&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ec8c80"]])

export default __exports__